var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["global-promo.j2"] = require( "global-promo.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/promo-style-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["promo"], 
[], 
function (l_promo, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("promo", l_promo);
var t_2 = "";t_2 += "\n    ";
if(runtime.memberLookup((l_promo),"bannerWrapperBackgroundColor")) {
t_2 += "\n        style=\"background-color: #";
t_2 += runtime.suppressValue(runtime.memberLookup((l_promo),"bannerWrapperBackgroundColor"), env.opts.autoescape);
t_2 += ";\"\n    ";
;
}
else {
if(runtime.memberLookup((l_promo),"bannerBackgroundImage") && runtime.memberLookup((l_promo),"backgroundImageType") == "repeat") {
t_2 += "\n        style=\"background-image: url(";
t_2 += runtime.suppressValue(runtime.memberLookup((l_promo),"bannerBackgroundImage"), env.opts.autoescape);
t_2 += "); background-repeat: repeat;\"\n    ";
;
}
else {
if(runtime.memberLookup((l_promo),"bannerBackgroundImage") && runtime.memberLookup((l_promo),"backgroundImageType") == "cover") {
t_2 += "\n        style=\"background-image: url(";
t_2 += runtime.suppressValue(runtime.memberLookup((l_promo),"bannerBackgroundImage"), env.opts.autoescape);
t_2 += "); background-size: cover;\"\n    ";
;
}
;
}
;
}
t_2 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("setPromoStyle");
context.setVariable("setPromoStyle", macro_t_1);
var macro_t_3 = runtime.makeMacro(
["promoType"], 
[], 
function (l_promoType, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("promoType", l_promoType);
var t_4 = "";t_4 += "\n    ";
env.getTemplate("global-promo.j2", false, "core/templates/macros/promo-style-macro.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_4 += t_6
t_4 += "\n";
})});
frame = frame.pop();
return new runtime.SafeString(t_4);
});
context.addExport("promo_include");
context.setVariable("promo_include", macro_t_3);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/promo-style-macro.j2"] , dependencies)